import {HttpClient, HttpParams, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CustomHttpUrlEncodingCodec} from 'src/app/main/encoder';
import {MovieDbCredit} from 'src/app/model/cms-vod-core/moviedb-models/movidb-credit.model';
import {FindFromMovieDb} from 'src/app/model/cms-vod-core/moviedb-models/moviedb-find-model';
import {SearchMovies, SearchTvShows} from 'src/app/model/cms-vod-core/moviedb-models/moviedb-search-model';
import {PersonDetail, TheMovieDb} from 'src/app/model/imdb-model';

@Injectable({
  providedIn: 'root',
})
export class ImdbService {
  readonly movieDbUrl = 'https://api.themoviedb.org/3';

  constructor(private http: HttpClient) {}

  public defaultHeaders = new HttpHeaders();

  searchMovieFromTheMovieDb(query: string, type: string): Observable<any> {
    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (type == 'SERIES' || type == 'SEASON' || type == 'EPISODE') {
      if (query) {
        queryParameters = queryParameters.set('api_key', <any>'17909efd2cb611dd7ca26690fec3a08a');
        queryParameters = queryParameters.set('query', <any>query);
      }

      return this.http.get<SearchTvShows>(this.movieDbUrl + `/search/tv`, {params: queryParameters});
    } else {
      if (query) {
        queryParameters = queryParameters.set('api_key', <any>'17909efd2cb611dd7ca26690fec3a08a');
        queryParameters = queryParameters.set('query', <any>query);
      }

      return this.http.get<SearchMovies>(this.movieDbUrl + `/search/movie`, {params: queryParameters});
    }
  }

  getCasts(imdbID: string, isSerie: boolean): Observable<TheMovieDb> {
    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    queryParameters = queryParameters.set('api_key', <any>'17909efd2cb611dd7ca26690fec3a08a');
    let type: string = '';
    if (isSerie) {
      type = 'tv';
    } else {
      type = 'movie';
    }

    return this.http.get<TheMovieDb>(`${this.movieDbUrl}/${type}/${imdbID}/credits`, {
      params: queryParameters,
      observe: 'body',
      reportProgress: false,
    });
  }

  public getEpisodeCasts(imdbID: string, seasonNo: number, episodeNo: string): Observable<any> {
    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    queryParameters = queryParameters.set('api_key', <any>'17909efd2cb611dd7ca26690fec3a08a');
    //queryParameters = queryParameters.set('external_source', <any>'imdb_id');

    return this.http.get<any>(`${this.movieDbUrl}/tv/${imdbID}/season/${seasonNo}/episode/${episodeNo}/credits`, {
      params: queryParameters,
      observe: 'body',
      reportProgress: false,
    });
  }

  getDetailOfContentFromMovieDb(imdbId: string): Observable<FindFromMovieDb> {
    let queryParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (imdbId) {
      queryParams = queryParams.set('api_key', <any>'17909efd2cb611dd7ca26690fec3a08a');
      queryParams = queryParams.set('external_source', <any>'imdb_id');
    }
    return this.http.get<FindFromMovieDb>(this.movieDbUrl + `/find/${imdbId}`, {params: queryParams});
  }

  // This method works for get records of the moviedb
  getTvShowCasts(moviedbId: number): Observable<any> {
    let queryParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (moviedbId) {
      queryParams = queryParams.set('api_key', <any>'17909efd2cb611dd7ca26690fec3a08a');
      queryParams = queryParams.set('language', <any>'en-US');
    }
    return this.http.get<any>(this.movieDbUrl + `/tv/${moviedbId}/credits`, {params: queryParams});
  }

  getSeasonCasts(moviedbId: string, seasonNo: number): Observable<any> {
    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    queryParameters = queryParameters.set('api_key', <any>'17909efd2cb611dd7ca26690fec3a08a');
    //queryParameters = queryParameters.set('external_source', <any>'imdb_id');
    return this.http.get<any>(`${this.movieDbUrl}/tv/${moviedbId}/season/${seasonNo}/credits`, {
      params: queryParameters,
      observe: 'body',
      reportProgress: false,
    });
  }

  getPersonDetail(): Observable<PersonDetail> {
    return this.http.get<PersonDetail>(this.movieDbUrl);
  }
}
